export default __webpack_public_path__ + "e50d2e87b759fac18e381d7b3152b587.svg";